// https://ecoflow.feishu.cn/docx/CpeOdkWaGoLxaJxVBKPccmM3nQe
// https://ecoflow.feishu.cn/sheets/FdGtsLtO6hWf5ztbk9AcYZrInrb
export const EU_IPS: string[] = [
    'cis',
    'ru',
    'ie', // 爱尔兰
    'ad', // 安道尔
    'at', // 奥地利
    'bg', // 保加利亚
    'be', // 比利时
    'pl', // 波兰
    'dk', // 丹麦
    'fl', // 芬兰
    'nl', // 荷兰
    'me', // 黑山
    'cz', // 捷克共和国
    'sk', // 斯洛伐克
    'hr', // 克罗地亚
    'lv', // 拉脱维亚
    'ro', // 罗马尼亚
    'mt', // 马耳他
    'md', // 摩尔多瓦
    'no', // 挪威
    'pt', // 葡萄牙
    'se', // 瑞典
    'ch', // 瑞士
    'rs', // 塞尔维亚
    'cy', // 塞浦路斯
    'sl', // 斯洛文尼亚
    'gr', // 希腊
    'hu', // 匈牙利
    'by', // 白俄罗斯
    'ua', // 乌克兰
    'kz', // 哈萨克斯坦
    'ge', // 格鲁吉亚
];
